<ion-header [translucent]="true">
  <ion-toolbar color="primary" class="custom-toolbar">

    <!-- Updated Level Indicator with both buttons -->
    <div class="level-indicator" slot="primary">
      <div class="level-glow"></div>
      <div class="level-text">
        <div class="help-button" (click)="showManual = !showManual">
          <ion-icon name="keypad-outline"></ion-icon>
          <span>{{ 'Keyboard Help' | translate }}</span>
        </div>
        <div class="divider"></div>
        <div class="help-button" routerLink="/typing">
          <ion-icon name="school-outline"></ion-icon>
          <span>{{ 'Typing Lessons' | translate }}</span>
        </div>
      </div>
    </div>

    <ion-button slot="start" size="small" routerLink="/"><ion-icon name="book-outline"></ion-icon> {{ 'Learn' | translate }}</ion-button>
    <ion-button slot="end" size="small" (click)="clear()"><ion-icon name="trash-outline"></ion-icon> {{ 'Clear' | translate }}</ion-button>
  </ion-toolbar>
  <div class="transliteration-container" *ngIf="romanTransliteration">
    <div class="transliteration-pill">
      <span class="transliteration-text">{{romanTransliteration}}</span>
    </div>
  </div>
</ion-header>

<ion-content [style]="contentStyle">

<!-- Info Section -->
<div *ngIf="showManual" class="info-section">
  <div class="user-manual">
    <!-- Add sticky close button -->
    <div class="sticky-close">
      <ion-button (click)="closeManual()" color="light" fill="clear">
        <ion-icon name="close-circle" slot="icon-only"></ion-icon>
      </ion-button>
    </div>

    <ion-card>
      <ion-card-header>
        <ion-card-title>Tamil UyirMei Keyboard Layout!</ion-card-title>
      </ion-card-header>
      <ion-card-content>
        <p>This manual will help you understand how to use the keyboard effectively to type Tamil characters.</p>

        <h2>1. Overview</h2>
        <div class="content-block">
          <p>The keyboard is divided into sections consists of:</p>
          <ul>
            <li>Uyir (Vowels): Displayed on the left side.</li>
            <li>Mei (Consonants): Displayed on the right side according to Tamil Grammar rules.</li>
            <li>Special Keys: Includes ஃ, SPACE, DELETE, and ENTER.</li>
          </ul>
          <div class="keyboard-image">
            <img src="assets/images/tamil.my-uyirmei-keyboard.png" alt="Tamil UyirMei Keyboard">
          </div>
        </div>
                  

        <h2>2. Using the Keyboard</h2>
        <h3>Uyir (Vowels) Keys</h3>
        <div class="content-block">
          <p>The vowels are displayed in three rows. Clicking a vowel key will input the selected vowel into the text field.</p>
          <p>First Row: அ, ஆ, இ, ஈ</p>
          <p>Second Row: உ, ஊ, எ, ஏ</p>
          <p>Third Row: ஐ, ஒ, ஓ, ஔ</p>
          <div class="keyboard-uyir">
            <img src="assets/images/tamil.my-uyirmei-keyboard-uyir.png" alt="Tamil UyirMei Keyboard">
          </div>
        </div>

        <h3>Mei (Consonants) Keys</h3>
        <div class="content-block">
          <p>The consonants are organized according to Tamil Grammar rules and displayed in three rows. Clicking a consonant key will input the selected consonant into the text field.</p>
          <p>First Row (வல்லினம் Vallinam): க், ச், ட், த், ப், ற்</p>
          <p>Second Row (மெல்லினம் Mellinam): ங், ஞ், ண், ந், ம், ன்</p>
          <p>Third Row (இடையினம் Idaiyinam): ய், ர், ல், வ், ழ், ள்</p>
          <div class="keyboard-mei">
            <img src="assets/images/tamil.my-uyirmei-keyboard-mei.png" alt="Tamil UyirMei Keyboard">
          </div>
        </div>

        <h3>Special Keys</h3>
<div class="content-block">
  <ul>
    <li>ஃ: This is a special Tamil character.</li>
    <li>SPACE: Inserts a space character into the text field.</li>
    <li>DELETE: Deletes the last character in the text field.</li>
    <li>ENTER: Submits the input.</li>
  </ul>
  <div class="keyboard-special">
    <img src="assets/images/tamil.my-uyirmei-keyboard-special.png" alt="Tamil UyirMei Keyboard Special Keys">
  </div>
</div>
        
        <h3>UyirMei Combinations</h3>
        <div class="content-block">
          <p>The keyboard intelligently handles combinations of consonants and vowels to form compound UyirMei characters. When you click a consonant followed by a vowel, it automatically forms the combined character.</p>
          <p>For example: Clicking க் followed by ஆ will form கா.</p>
        </div>

        <h3>Handling Special Keys</h3>
        <div class="content-block">
          <p>DELETE Key: If you make a mistake, click the DELETE key to remove the last character.</p>
          <p>ENTER Key: Click the ENTER key to submit your input.</p>
        </div>

        <h2>3. Example Usages</h2>
        <h3>Typing a Word</h3>
        <div class="content-block">
          <p>To type the word "தமிழ்":</p>
          <ul>
            <li>Click த்</li>
            <li>Click த(அ)</li>
            <li>Click ம்</li>
            <li>Click மி(இ)</li>
            <li>Click ழ்</li>
          </ul>
          <p>The result will be "தமிழ்".</p>
        </div>

        <h3>Deleting a Character</h3>
        <div class="content-block">
          <p>If you want to delete the last character:</p>
          <ul>
            <li>Click DELETE</li>
          </ul>
          <p>This will remove the last character from the text field.</p>
        </div>

        <h3>Submitting the Input</h3>
        <div class="content-block">
          <p>When you have completed typing and want to submit:</p>
          <ul>
            <li>Click ENTER</li>
          </ul>
          <p>This will submit your input for processing.</p>
        </div>

        <h2>4. Tips and Tricks</h2>
        <div class="content-block">
          <ul>
            <li>Combining Characters: Always click the consonant first and then the vowel to form combined characters.</li>
            <li>Resetting Input: If you need to start over, you can use the DELETE key to clear characters one by one.</li>
            <li>Switching Rows: Click on the vowel/consonant of your choice from the respective rows.</li>
          </ul>
        </div>
      </ion-card-content>

      <div class="footer-note">
        <p>Tamil UyirMei Keyboard Layout developed by Muhelen Murugan</p>
      </div>     
    </ion-card> 
  </div> 

</div>

<!-- Update the input-container div condition -->
<div *ngIf="!showManual" class="input-container">

  <textarea [placeholder]="" 
    [(ngModel)]="userAttempt" 
    (input)="onInputChange($event)"
    [attr.inputmode]="(isMobilePlatform || isSystemTamilKeyboard) ? 'text' : 'none'"
    type="text">
  </textarea>
  
  <!-- Combined status and sound indicator -->
  <div class="word-status-container" *ngIf="userAttempt.trim()">
    <div class="word-status" [ngClass]="{
      'success': hasCompleteWord,
      'playing': isPlaying
    }">
      <div class="status-content" (click)="hasCompleteWord ? replayWord() : null" [class.clickable]="hasCompleteWord">
        <ion-icon *ngIf="hasCompleteWord" 
                  name="volume-high-outline" 
                  class="sound-wave">
        </ion-icon>
        <span>{{ hasCompleteWord ? ('Replay' | translate) : ('Keep typing...' | translate) }}</span>
      </div>
    </div>
  </div>
</div>

<!-- Update the keyboard-wrapper div condition -->
<div *ngIf="!showManual" class="keyboard-wrapper">
  <app-keyboard></app-keyboard>
</div>
</ion-content>

<ion-footer class="ion-no-border">
  <div class="ion-text-center footer-style">
    <span>© 2025 TAMIL.MY · <a href="https://otpam.com" target="_blank" class="footer-link">OTPAM SDN BHD (1446394-V).</a> All Rights Reserved.</span>
  </div>     
</ion-footer>